import { Component, Inject } from "@angular/core";
import { CrewPermissionsService } from "../../core/crew-permissions.service";

@Component({
    selector: "crew-work-groups",
    template: require('./work-groups.component.html')
})
export class WorkGroupsComponent {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject("workGroups") public workGroups: Nema.Crew.Model.WorkGroup[],
        @Inject("workplaces") public workplaces: Nema.Crew.Model.Workplace[],
        crewPermissionsService: CrewPermissionsService) {

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);

        // Set a custom DisplayName property
        workGroups.forEach(workGroup => (<any>workGroup).DisplayName = `${workGroup.Name} ${workGroup.Workplace != null ? "(" + workGroup.Workplace.Name + ")" : ""}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/workgroups/work-groups.component.ts